import { PERMISSION } from "../constants";
import { APP_PATH } from "constants/path";
import React from "react";
import { lazyRetry } from "utils/route";

import { BgColorsOutlined, InfoOutlined } from "@ant-design/icons";

const CarCareList = React.lazy(() =>
	lazyRetry(() => import("../features/car-care/CarCareList")),
);
const CarCareDetail = React.lazy(() =>
	lazyRetry(() => import("../features/car-care/CarCareDetail")),
);

const carCareRoutes = [
	// car care list
	{
		label: "Car care",
		path: APP_PATH.carCares,
		key: "car-cares",
		icon: <BgColorsOutlined />,
		children: [],
		component: <CarCareList />,
		permissions: [],
	},
	{
		label: "Details",
		path: `${APP_PATH.carCares}/:id`,
		key: "car-cares",
		icon: <InfoOutlined />,
		children: [],
		component: <CarCareDetail />,
		hidden: true,
		permissions: [],
	},
];

export default carCareRoutes;
